import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from '@mui/material';
import { useController, useFormContext, useForm } from 'react-hook-form';

export default function RadioInput(props) {

  const { label, name, onChange, radios, inputRef, hideLabel, hideError, onBlur, ...radioGroupProps } = props;
  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm;

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control
  });

  const handleChange = (newValue) => {
    field.onChange(newValue);
    onChange && onChange(newValue);
  };

  const handleBlur = (event) => {
    field.onBlur(); // Ensures react-hook-form validation runs
    onBlur && onBlur(event); // Calls parent onBlur if provided
  };

  const formControlLabels = radios && radios.map((option, key) => {
    return (
      <FormControlLabel value={option.value} key={key} label={option.label} control={<Radio color="primary" onChange={handleChange} onBlur={handleBlur} slotProps={{
        input: {
          ref: inputRef
        }
      }} />} />
    );
  })

  return (
    <div className='radio-input-box'>
      <FormControl component="fieldset" error={!!error}>

        {(!hideLabel) &&
          <FormLabel component="legend" className='lh-1'>{label}</FormLabel>
        }

        <RadioGroup {...radioGroupProps} role="">
          {formControlLabels}
        </RadioGroup>

        {(!hideError) &&
          <FormHelperText className='mx-0'>{error?.message}</FormHelperText>
        }
      </FormControl>
    </div>
  )

}

RadioInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  radios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  inputRef: PropTypes.any,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  hideError: PropTypes.bool,
  onBlur: PropTypes.func,
}
